import * as React from 'react';

var CaretDown = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Toggle' : _b;
    return (React.createElement("svg", { height: "13", viewBox: "0 0 19 13", width: "19", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", null, title),
        React.createElement("path", { d: "M9.838 12.332l9.03-9.741c.176-.225.176-.609 0-.865L18.044.668c-.175-.224-.475-.224-.675 0L9.513 8.903 1.633.7C1.456.476 1.156.476.956.7L.13 1.758c-.175.224-.175.608 0 .865l9.031 9.709c.2.224.5.224.676 0z", fillRule: "evenodd" })));
};

export { CaretDown as default };
//# sourceMappingURL=CaretDown.esm.js.map
